module.exports = __webpack_public_path__ + "static/img/8-9.0aa4e50e.jpg";